var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReddit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "#ff4500"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 516c0-30.9-25.1-56-56-56-15.1 0-28.8 6-38.9 15.7-38.3-27.6-91.1-45.5-149.8-47.5l25.5-120.1 83.4 17.7c1 21.2 18.4 38.1 39.8 38.1 22.1 0 40-17.9 40-40s-17.9-40-40-40c-15.7 0-29.2 9.1-35.7 22.3l-93.1-19.8c-2.6-.6-5.3-.1-7.5 1.4-2.2 1.4-3.8 3.7-4.3 6.3l-28.5 134c-59.6 1.7-113.2 19.5-152 47.5-10.1-9.7-23.7-15.6-38.7-15.6-30.9 0-56 25.1-56 56 0 22.8 13.6 42.3 33.1 51.1-.9 5.6-1.3 11.2-1.3 16.9 0 86.2 100.3 156.1 224.1 156.1S736 670.2 736 584c0-5.7-.5-11.3-1.3-16.8 19.6-8.7 33.3-28.3 33.3-51.2zm-384.1 40c0-22.1 18-40 40-40 22.1 0 40 18 40 40 0 22.1-17.9 40-40 40s-40-17.9-40-40zM607 661.8c-27.3 27.3-79.7 29.4-95 29.4-15.4 0-67.7-2.1-95-29.4-4-4-4-10.6 0-14.7 4-4 10.6-4 14.7 0 17.2 17.2 54 23.3 80.3 23.3 26.3 0 63.1-6.1 80.4-23.3 4.1-4 10.6-4 14.7 0 4 4.1 4 10.6-.1 14.7zm-7-65.8c-22.1 0-40-18-40-40 0-22.1 18-40 40-40 22.1 0 40 18 40 40 0 22.1-18 40-40 40z",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/reddit.06c52a6c6103cfb7e78b63a879415b90.svg";
export { ForwardRef as ReactComponent };